import { Tag, Typography } from "antd";

const { Text } = Typography;

/**
 * Values double as the `:profileType` segment of the shared backend API
 * (`/admin/website-featured-profiles/:profileType/...`).
 */
export const WEBSITE_FEATURED_PROFILE_TYPES = {
  MENTOR: "mentor",
  TESTIMONIAL: "testimonial"
};

// Values must match the backend's SOCIAL_PLATFORMS enum exactly — it is a
// strict zod enum, so a casing mismatch rejects the whole write.
export const SOCIAL_PLATFORM_OPTIONS = [
  { label: "LinkedIn", value: "linkedin" },
  { label: "X ", value: "x" },
  { label: "Codeforces", value: "codeforces" }
];

/**
 * Per-type UI wiring for the shared dashboard and modal. Adding a new
 * featured surface only needs a backend registry entry plus an entry here.
 */
export const PROFILE_TYPE_UI_CONFIG = {
  [WEBSITE_FEATURED_PROFILE_TYPES.MENTOR]: {
    accessKey: "websiteFeaturedProfiles",
    entityLabel: "Mentor",
    pageTitle: "Website Mentors",
    pageDescription:
      "Manage the mentors featured on the public website (Our Journey / Our Mentors). ",
    typeColumns: [
      {
        title: "Institute",
        dataIndex: "instituteName",
        key: "instituteName",
        width: 180
      },
      {
        title: "Codeforces",
        key: "codeforces",
        width: 150,
        render: ({ codeforcesDetails: { maxRating, maxTitle } = {} }) =>
          maxRating ? (
            <Tag color="volcano">
              {maxTitle || "rated"} · {maxRating}
            </Tag>
          ) : (
            <Text type="secondary">—</Text>
          )
      },
      {
        title: "Cohort",
        dataIndex: "isCurrentMentor",
        key: "isCurrentMentor",
        width: 110,
        render: (isCurrentMentor) =>
          isCurrentMentor ? <Tag color="green">Current</Tag> : <Tag>Past</Tag>
      }
    ]
  },
  [WEBSITE_FEATURED_PROFILE_TYPES.TESTIMONIAL]: {
    accessKey: "websiteFeaturedProfiles",
    entityLabel: "Testimonial",
    pageTitle: "Website Testimonials",
    pageDescription:
      "Manage the student testimonials shown across the public website (home page, course pages). ",
    typeColumns: [
      {
        title: "Testimonial",
        dataIndex: "displayTestimonialText",
        key: "displayTestimonialText",
        width: 320,
        render: (displayTestimonialText) => (
          <Text style={{ whiteSpace: "normal", wordWrap: "break-word" }}>
            {displayTestimonialText}
          </Text>
        )
      },
      {
        title: "Attribution",
        dataIndex: "displayAffiliationText",
        key: "displayAffiliationText",
        width: 160,
        render: (displayAffiliationText) =>
          displayAffiliationText ? (
            <Text type="secondary">{displayAffiliationText}</Text>
          ) : (
            <Text type="secondary">—</Text>
          )
      }
    ]
  }
};
